<template>
	<section>
		<MainLayout>
			<iframe src="https://p.us5.datadoghq.com/sb/embed/d876666c-ae77-11ef-98a7-6ecd5e8e56fb-afb6791c8c84000efde999d5200e4088" title="Dashboard Name" width="100%" height="800"></iframe>
		</MainLayout>
	</section>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
export default {
	components: {
		MainLayout
	},
	computed: {
		user() {
			return this.$root.store.state.currentUser;
		}
	}
};
</script>

<style scoped>
.hello {
	width: 500px;
	height: auto;
}
.container {
	max-width: 600px;
}

</style>
<style>

</style>
